import { render, staticRenderFns } from "./SalesTaxReportResults.vue?vue&type=template&id=6b8d15a2&scoped=true&"
import script from "./SalesTaxReportResults.vue?vue&type=script&lang=js&"
export * from "./SalesTaxReportResults.vue?vue&type=script&lang=js&"
import style0 from "./SalesTaxReportResults.vue?vue&type=style&index=0&id=6b8d15a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8d15a2",
  null
  
)

export default component.exports